import { render, staticRenderFns } from "./InputComponent.vue?vue&type=template&id=bc9f16de&"
import script from "./InputComponent.vue?vue&type=script&lang=js&"
export * from "./InputComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports